// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"400fe6d6","45":"846bf46a","151":"050a3a50","169":"a03a213b","443":"e2ae8414","779":"8f27cda9","867":"e79c5b88","954":"690a6eef"}[chunkId] + ".chunk.js";
};